import PropTypes from 'prop-types';

const Minimize = ({ color, size, ...props }) => (
    <svg viewBox="0 0 20 20" width={size} height={size} {...props}>
        <g fill={color} fillRule="nonzero">
            <path d="M8 11a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-5H2a1 1 0 0 1-.993-.883L1 12a1 1 0 0 1 1-1zM12 1a1 1 0 0 1 1 1v5h5a1 1 0 0 1 .993.883L19 8a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1" />
            <path d="M18.293.293a1 1 0 0 1 1.414 1.414l-7 7a1 1 0 0 1-1.414-1.414zM7.293 11.293a1 1 0 0 1 1.414 1.414l-7 7a1 1 0 1 1-1.414-1.414z" />
        </g>
    </svg>
);

export default Minimize;

Minimize.propTypes = {
    color: PropTypes.string.isRequired,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
